import type { JobCardDataFragment } from '../../../graphQL/fragments/__generated__/jobCardData.gqlgenerated';
import type { AppearanceMode } from '../JobCard';

import { Text , Box } from '../../../../mads';
import { LocationComponent } from '../LocationComponent/LocationComponent';


import { Platform, StyleSheet } from 'react-native';

export type CompanyInfoProps = {
    job: JobCardDataFragment;
    appearanceMode: AppearanceMode;
};

export function CompanyInfo({ job, appearanceMode }: CompanyInfoProps) {
    // Validate commute time
    const attributeKeys = job.attributes.map((attr) => attr.key);
    const REMOTE_WORK_ATTR = 'DSQF7';
    const TEMPORARILY_REMOTE_WORK_ATTR = 'VAMUB';
    const commuteTime =
        job.commute?.durationMinutes &&
        job.commute.durationMinutes > 0 &&
        job.commute.durationMinutes <= 120 &&
        !attributeKeys.includes(REMOTE_WORK_ATTR) &&
        !attributeKeys.includes(TEMPORARILY_REMOTE_WORK_ATTR)
            ? job.commute.durationMinutes
            : undefined;

    return (
        <Box sx={styles.root} >
            <Box 
                sx={styles.horizontal}
                {...Platform.select({
                    ios: { accessible: true },
                    android: { screenReaderFocusable: true },
                })}
            >
                <Text sx={styles.companyName}>
                    {job.sourceEmployerName}
                </Text>
            </Box>
            <LocationComponent
                accessible={false}
                jobKey={job.key}
                commuteTimeMinutes={commuteTime}
                location={job.location.formatted}
                appearanceMode={appearanceMode}
                attributes={job.attributes}
            />
        </Box>
    );
}

const styles = StyleSheet.create({
    root: {
        flex: 1,
    },
    companyName: {
        flexShrink: 1,
    },
    horizontal: {
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
});
